/**
 * This component allows jumping forwards and backwards through the
 * search results for a Log.
 */
import {RED_500} from '@wandb/weave/common/css/globals.styles';
import {Button} from '@wandb/weave/components/Button';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

type LogSearchBrowserProps = {
  index: number;
  count: number;
  onSetIndex: (index: number) => void;
};

const NoMatches = styled.span`
  color: ${RED_500};
  margin-left: 8px;
`;
NoMatches.displayName = 'S.NoMatches';

const Matches = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
`;
Matches.displayName = 'S.Matches';

const Position = styled.span`
  margin-left: 8px;
`;
Position.displayName = 'S.Position';

export const LogSearchBrowser = ({
  index,
  count,
  onSetIndex,
}: LogSearchBrowserProps) => {
  if (count === 0) {
    return <NoMatches>No matches</NoMatches>;
  }
  const onUp = () => {
    onSetIndex(index - 1);
  };
  const onDown = () => {
    onSetIndex(index + 1);
  };
  return (
    <Matches>
      <Button
        icon="chevron-up"
        size="small"
        variant="ghost"
        onClick={onUp}
        disabled={index === 0}
      />
      <Button
        icon="chevron-down"
        size="small"
        variant="ghost"
        onClick={onDown}
        disabled={index === count - 1}
      />
      <Position>
        {index + 1}/{count}
      </Position>
    </Matches>
  );
};
